import { render, staticRenderFns } from "./v-file-input-v2.vue?vue&type=template&id=4100b544&"
import script from "./v-file-input-v2.vue?vue&type=script&lang=js&"
export * from "./v-file-input-v2.vue?vue&type=script&lang=js&"
import style0 from "./v-file-input-v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
